import React from 'react';

type Variant = 'nodes' | 'grid' | 'hexagon' | 'waves' | 'circles';

interface TechPatternProps {
  variant?: Variant;
  opacity?: number;
  color?: string;
}

const patterns: Record<Variant, (color: string) => string> = {
  nodes: (c) => `url("data:image/svg+xml,%3Csvg width='400' height='400' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='50' cy='50' r='3' fill='${c}'/%3E%3Ccircle cx='200' cy='100' r='4' fill='${c}'/%3E%3Ccircle cx='350' cy='50' r='3' fill='${c}'/%3E%3Ccircle cx='100' cy='200' r='4' fill='${c}'/%3E%3Ccircle cx='300' cy='200' r='3' fill='${c}'/%3E%3Ccircle cx='50' cy='350' r='3' fill='${c}'/%3E%3Ccircle cx='200' cy='300' r='4' fill='${c}'/%3E%3Ccircle cx='350' cy='350' r='3' fill='${c}'/%3E%3Cline x1='50' y1='50' x2='200' y2='100' stroke='${c}' stroke-width='0.5'/%3E%3Cline x1='200' y1='100' x2='350' y2='50' stroke='${c}' stroke-width='0.5'/%3E%3Cline x1='200' y1='100' x2='100' y2='200' stroke='${c}' stroke-width='0.5'/%3E%3Cline x1='200' y1='100' x2='300' y2='200' stroke='${c}' stroke-width='0.5'/%3E%3Cline x1='100' y1='200' x2='200' y2='300' stroke='${c}' stroke-width='0.5'/%3E%3Cline x1='300' y1='200' x2='200' y2='300' stroke='${c}' stroke-width='0.5'/%3E%3Cline x1='50' y1='350' x2='200' y2='300' stroke='${c}' stroke-width='0.5'/%3E%3Cline x1='200' y1='300' x2='350' y2='350' stroke='${c}' stroke-width='0.5'/%3E%3C/svg%3E")`,

  grid: (c) => `url("data:image/svg+xml,%3Csvg width='60' height='60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h60v60H0z' fill='none'/%3E%3Cpath d='M0 30h60M30 0v60' stroke='${c}' stroke-width='0.5'/%3E%3C/svg%3E")`,

  hexagon: (c) => `url("data:image/svg+xml,%3Csvg width='120' height='104' xmlns='http://www.w3.org/2000/svg'%3E%3Cpolygon points='60,2 110,28 110,76 60,102 10,76 10,28' fill='none' stroke='${c}' stroke-width='0.8'/%3E%3C/svg%3E")`,

  waves: (c) => `url("data:image/svg+xml,%3Csvg width='200' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 20c25-15 75 15 100 0s75 15 100 0' fill='none' stroke='${c}' stroke-width='0.8'/%3E%3C/svg%3E")`,

  circles: (c) => `url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='100' cy='100' r='80' fill='none' stroke='${c}' stroke-width='0.5'/%3E%3Ccircle cx='100' cy='100' r='50' fill='none' stroke='${c}' stroke-width='0.5'/%3E%3Ccircle cx='100' cy='100' r='20' fill='none' stroke='${c}' stroke-width='0.5'/%3E%3C/svg%3E")`,
};

const TechPattern: React.FC<TechPatternProps> = ({
  variant = 'nodes',
  opacity = 0.06,
  color = '%232563eb',
}) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: patterns[variant](color),
        backgroundRepeat: 'repeat',
        opacity,
        pointerEvents: 'none',
        zIndex: 0,
      }}
    />
  );
};

export default TechPattern;
